import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20comic%20style%20background%20with%20dynamic%20speed%20lines%20ink%20splashes%20and%20vibrant%20warm%20orange%20red%20gradients%20on%20dark%20background%2C%20Japanese%20manga%20aesthetic%20with%20bold%20graphic%20elements%2C%20action%20lines%20and%20halftone%20dots%2C%20cinematic%20composition&width=1600&height=900&seq=fqmh-hero-bg&orientation=landscape"
        alt="番茄漫画 - 追更漫画连载更新"
        title="番茄漫画 - 追更漫画连载更新 | 最新话追漫提醒免费全集完结韩漫日漫国漫"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50/90 whitespace-nowrap">每日更新 · 免费阅读</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          追更漫画<span className="text-accent-500">从不掉队</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-2xl mx-auto leading-relaxed">
          最新话追漫提醒，免费全集完结韩漫日漫国漫，流畅下拉式滚动在线阅读体验 — 番茄漫画，你的追漫必备神器。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/riman"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg font-semibold text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-8 text-background-50/80">
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">12+</p>
            <p className="text-xs mt-1">热门连载</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">500万+</p>
            <p className="text-xs mt-1">累计阅读</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-bold text-background-50">3大分类</p>
            <p className="text-xs mt-1">日漫·韩漫·国漫</p>
          </div>
        </div>
      </div>
    </section>
  );
}